import {createFeatureSelector, createSelectorFactory, MemoizedProjection} from '@ngrx/store';
import { State } from './contacts.reducer';
import {AnyFn} from '@ngrx/store/src/selector';

export const getContactsFeature = createFeatureSelector<State>('contacts');

export function isEqual(a: any, b: any): boolean {
    return a.totalRows === b.totalRows &&
        a.contacts.every(fromA => b.contacts.includes(fromA));
}

export function customMemoize(t: AnyFn): MemoizedProjection {
    let lastResult: any = null;

    function memoized(): any {
        const result = t.apply(null, arguments);

        if (lastResult == null || !isEqual(result, lastResult)) {
            lastResult = result;
            return result;
        }
        return lastResult;
    }

    function reset() { lastResult = null; }

    return {
        clearResult(): void {
        }, setResult(result: any): void {
        }, memoized, reset};
}

export const getContacts = createSelectorFactory(customMemoize)(
    getContactsFeature,
    (state) => {
        return {
            contacts: state.contacts,
            totalRows: state.totalRows,
            currentLazyLoad: state.currentLazyLoad
        };
    }
);
